import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=449e9ed7&scoped=true&"
import script from "./TeamMember.vue?vue&type=script&lang=ts&"
export * from "./TeamMember.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=449e9ed7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449e9ed7",
  null
  
)

export default component.exports